import { RequestAutomationType } from '@app/src/pages/Configurations/ConfigurationsPages/Automation/RequestAutomationType'
import type { RequestAutomation } from '@app/src/types/automations'
import type { ExpectationAutomation } from '@app/src/types/expectations'
import { isExpectationAutomationActive } from './ExpectationAutomation/expectationAutomationLogic'

export interface AutomationCardItem {
  id: number
  type: 'request' | 'expectation'
  createdAt: string
  updatedAt?: string
  isActive: boolean
  automationType: RequestAutomationType
  templateNames: string[]
  requestAutomation?: RequestAutomation
  expectationAutomation?: ExpectationAutomation
}

export function combineAutomations(
  requestAutomations: RequestAutomation[],
  expectationAutomations: ExpectationAutomation[],
): AutomationCardItem[] {
  const requestItems: AutomationCardItem[] = requestAutomations.map(r => ({
    id: r.id,
    type: 'request',
    createdAt: r.createdAt,
    updatedAt: r.updatedAt,
    isActive: r.isActive,
    automationType: r.automationType,
    templateNames: r.templateAutomations?.map(t => t.template.title) ?? [],
    requestAutomation: r,
  }))

  const expectationItems: AutomationCardItem[] = expectationAutomations.map(e => ({
    id: e.id,
    type: 'expectation',
    createdAt: e.createdAt,
    updatedAt: e.updatedAt,
    isActive: isExpectationAutomationActive(e),
    automationType: RequestAutomationType.EXPECTATION,
    templateNames: e.assessmentTemplate ? [e.assessmentTemplate?.name] : [],
    expectationAutomation: e,
  }))

  return [...requestItems, ...expectationItems].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  )
}

interface AutoAcceptProductMappingResponsesVisibility {
  isProductMappingEnabled: boolean
  hasFullProductMappingAccess: boolean
  isSourcingUser: boolean
  isTransparencyUser: boolean
}

export function canShowAutoAcceptProductMappingResponses({
  isProductMappingEnabled,
  hasFullProductMappingAccess,
  isSourcingUser,
  isTransparencyUser,
}: AutoAcceptProductMappingResponsesVisibility): boolean {
  return isProductMappingEnabled && hasFullProductMappingAccess && (isSourcingUser || isTransparencyUser)
}
